import { Controller } from "@hotwired/stimulus"

// One-click copy for the placements tab's playlist URLs (weekly report
// plan, section on tab links): ported from the playlists page's inline
// pattern into a reusable controller so all three tab variants share it.
export default class extends Controller {
  static values = { text: String }

  copy(event) {
    event.preventDefault()
    event.stopPropagation()
    navigator.clipboard.writeText(this.textValue).then(() => {
      const original = this.element.innerHTML
      this.element.innerHTML = "copied"
      setTimeout(() => { this.element.innerHTML = original }, 1500)
    })
  }
}
